import { createContext } from 'react';

export interface PushNotificationsContextValue {
  /**
   * If the feature is supported for the active platform and enabled for the app.
   */
  isSupported: boolean;

  /**
   * If it is possible to request permission by the user to send them push notifications.
   */
  canRequestPermission: boolean;

  /**
   * Whether the push notifications are presumed to be working by the app.
   */
  isOn: boolean;

  isTurningOnOrOff: boolean;

  turnOn(): Promise<void>;
  turnOff(): Promise<void>;
  requestPermission(): Promise<boolean>;
}

export const PushNotificationsContext =
  createContext<PushNotificationsContextValue>({
    isSupported: false,
    canRequestPermission: false,
    isOn: false,
    isTurningOnOrOff: false,
    turnOn: async () => {},
    turnOff: async () => {},
    requestPermission: async () => false,
  });
